import { Response } from '../../enums/response.enum';
import { enumToList } from '..';
import { Pipe, PipeTransform } from '@angular/core';
import { IdName } from 'src/app/shared/models/id-name.model';

@Pipe({
  name: 'response',
  standalone: false
})
export class ResponsePipe implements PipeTransform {
  public transform(value: Response): string {
    return getResponse(value);
  }
}

export function getResponse(value: Response): string {
  switch (value) {
    case Response.Create:
      return 'Created';
    case Response.Submit:
      return 'Submitted';
    case Response.Accept:
      return 'Accepted';
    case Response.Reject:
      return 'Rejected';
    case Response.AutoReject:
      return 'Auto-Rejected';
    case Response.Override:
      return 'Overridden';
    case Response.Updated:
      return 'Updated';
    case Response.SaveAsDraftForAll:
      return 'Updated';
    default:
      throw new Error(`Unsupported value for Response: ${value}.`);
  }
}

export function getResponseList(): IdName[] {
  return enumToList(Response, getResponse);
}
